const results = {
  loaderText: 'Your results are being calculated.',
  breakUp:
    '(If you need help breaking up with a Prick, nothing is stopping you from screenshotting your results and texting him.)',
  resultHeadline: percentage => {
    if (percentage < 40) return `Only ${percentage}% chance he’s a prick`;
    return `${percentage}% chance he’s a prick`;
  },
  resultText: percentage => {
    if (percentage >= 70) return 'Dangerous territory.';
    if (percentage < 70 && percentage >= 40) return 'Proceed with caution.';
    return 'Go for it.';
  },
  finalText: percentage => {
    if (percentage <= 30) return `Only ${percentage}% good guy :(`;
    if (percentage > 30 && percentage < 61) return `${percentage}% good guy :/`;
    return `${percentage}% good guy :)`;
  },
};

export default results;



// WEBPACK FOOTER //
// ./src/locales/results.js